import {Link} from '@smart/react-components';
import React from 'react';

interface IProps {
  text: string;
  map: Record<string, any>;
}

function isElement(node: ChildNode): node is Element {
  return !!(node as Element).tagName;
}

export function TextParser({text, map}: IProps): JSX.Element {
  const parser = new DOMParser();
  const doc = parser.parseFromString(text, `text/html`);

  const getAllAttrs = function (el: Element) {
    const atts = el.attributes;
    const n = atts.length;
    const arr = [];

    for (var i = 0; i < n; i++) {
      const att = atts[i];
      if (att) {
        arr.push([att.nodeName, att.value]);
      }
    }
    return Object.fromEntries(arr);
  };

  const m = new Text();

  const queryChild = (nodeList: NodeListOf<ChildNode>): JSX.Element => {
    return (
      <>
        {Array.from(nodeList).map((node, index) => {
          if (isElement(node)) {
            const props = map[node.tagName] || map[node.tagName.toLowerCase()];
            if (!!props) {
              return (
                <Link {...getAllAttrs(node)} {...props} key={index}>
                  {queryChild(node.childNodes)}
                </Link>
              );
            }
            return node.outerHTML;
          }
          return (node as typeof m).data;
        })}
      </>
    );
  };

  return queryChild(doc.body.childNodes);
}
